<div class="box-novo-compromisso" *ngIf="showModal" (click)="onBackgroundClick($event)">
  <div class="box-formulario" (click)="$event.stopPropagation()">
    <div class="row">
      <div class="col-md-8">
        <h5>Anexar documento ao lead #{{ atendimentoId }}</h5>
      </div>
      <div class="col-md-4 text-right" style="padding-top: 5px;">
        <i (click)="fecharModal()" class="fa fa-close"></i>
      </div>
      <hr class="hr-titulo">
      <div class="row">
        <div class="col-md-12">
          <div class="form-group">
            <label for="arquivo">Arquivo</label>
            <input id="arquivo" type="file" class="form-control" (change)="onFileChange($event)">
            <small class="text-muted" *ngIf="selectedFile">Selecionado: {{ selectedFile?.name }}</small>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6" style="padding-top: 10px;margin-top: 20px;">
          <button class="btn btn-warning" (click)="fecharModal()">Cancelar</button>
        </div>
        <div class="col-md-6 pull-right text-right" style="padding-top: 10px;margin-top: 20px;">
          <button class="btn btn-primary" [disabled]="!selectedFile" (click)="enviar()">Enviar</button>
        </div>
      </div>
    </div>
  </div>
</div>
